/*
 * @Date: 2022-03-18 22:37:12
 * @LastEditTime: 2022-03-29 16:05:07
 */
import React from 'react'
import * as Styles from './HotSearchModule.style'
import { Context } from '../HomeSearchPage'
import { setUbtInit, reportViewEvent, reportClickEvent } from '@weike/operation-report'

export function HotSearchModule() {
  const serachContext = React.useContext(Context)

  React.useEffect(() => {
    setUbtInit('opu2', 'search')
    reportViewEvent('page')
  }, [])

  const renderIndexStyle = (index: number) => {
    switch (index) {
      case 0:
        return { fontWeight: 500, color: '#F44336' }
      case 1:
        return { fontWeight: 500, color: '#FF5A31' }
      case 2:
        return { fontWeight: 500, color: '#FFBB22' }
      default:
        return {}
    }
  }

  const linkTo = (url: string, name: string, index: number) => {
    reportClickEvent('search__recommend', { index: index + 1, url, content: name })
    serachContext.dispatch({
      type: 'SET_SEARCH_HISTORY',
      payload: { value: name, ItemType: 'special', url }
    })
    setTimeout(() => {
      window.location.assign(url)
    }, 0)
  }

  const renderPopular = (num: number) => {
    if (num < 1e4) {
      return num
    } else {
      return `${+(num / 1e4).toFixed(1)}w`
    }
  }

  if (!serachContext.state || !serachContext.state.list_data || serachContext.state.list_data.length === 0) {
    return null
  }

  return (
    <div className={Styles.HotSearchModule}>
      <div className={Styles.HotSearchModuleTitleWrap}>
        <div className={Styles.HotSearchModuleTitle}>
          <p>热门搜索</p>
        </div>
      </div>
      <div className={Styles.hotSearchList}>
        <ul>
          {serachContext.state &&
            serachContext.state.list_data &&
            serachContext.state.list_data.map((item, index: number) => (
              <a style={{ textDecoration: 'none' }} onClick={() => linkTo(item.link, item.word, index)} key={item.priority}>
                <li className={Styles.hotSearchListItem}>
                  <div className={Styles.hotSearchListTitleWrap}>
                    <span className={Styles.hotSearchListIndex} style={renderIndexStyle(index)}>
                      {index + 1}
                    </span>
                    <p className={Styles.hotSearchListTitle}>{item.word}</p>
                  </div>
                  <div className={Styles.popularNums}>{renderPopular(item.hot_num)}</div>
                </li>
              </a>
            ))}
        </ul>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeSearchPage/HotSearch/HotSearchModule.tsx